module.exports = __webpack_public_path__ + "static/media/1005199.1f5de8c0.png";